import { Breadcrumb } from "antd";
import { useLocation } from "react-router-dom";

const routes: Record<string, string> = {
  // Dashboard
  "/dashboard": "Tổng quan hệ thống",

  // Transactions
  "/transactions": "Giao dịch",
  "/transactions/transaction-overview": "Lịch sử giao dịch",
  "/transactions/transaction-retry": "Thử lại",

  // Packages
  "/packages": "Gói cước",
  "/packages/create-packages-sponsor": "Thêm Data Sponsor",
  "/packages/create-packages-code": "Thêm Data Code",
  "/packages/edit-packages-sponsor": "Chỉnh sửa Data Sponsor",
  "/packages/edit-packages-code": "Chỉnh sửa Data Code",

  // Partners
  "/partners": "Đối tác",
  "/partners/partner-management": "Quản lý đối tác",
  "/partners/package-management": "Quản lý gói cước",
  "/partners/package-management/create-partner-sponsor": "Thêm Data Sponsor",
  "/partners/package-management/create-partner-sponsor-promotion": "Thêm khuyến mãi Data Sponsor",
  "/partners/package-management/edit-partner-sponsor": "Chỉnh sửa Data Sponsor",
  "/partners/package-management/edit-partner-sponsor-promotion": "Chỉnh sửa khuyến mãi Data Sponsor",
  "/partners/package-management/create-partner-code": "Thêm Data Code",
  "/partners/package-management/edit-partner-code": "Chỉnh sửa Data Code",

  // Account Management
  "/account-management": "Liên hệ",
  "/account-management/partners": "Danh sách đối tác",
  "/account-management/partners/create-partner": "Thêm mới đối tác",
  "/account-management/partners/edit-partner": "Chỉnh sửa đối tác",
  "/account-management/providers": "Danh sách nhà cung cấp",
  "/account-management/providers/create-network-provider": "Thêm mới nhà cung cấp",
  "/account-management/providers/create-vds-provider": "Thêm mới nhà cung cấp",
  "/account-management/providers/create-tdm-provider": "Thêm mới nhà cung cấp",
  "/account-management/providers/edit-network-provider": "Chỉnh sửa nhà cung cấp",
  "/account-management/providers/edit-vds-provider": "Chỉnh sửa nhà cung cấp",
  "/account-management/providers/edit-tdm-provider": "Chỉnh sửa nhà cung cấp",

  // Reports & Analytics
  "/reports-analytics": "Báo cáo & Phân tích",
  "/reports-analytics/transaction-reports": "Báo cáo giao dịch",
  "/reports-analytics/audit-trail-export": "Xuất nhật ký kiểm tra",
  "/reports-analytics/data-sponsor-statistics": "Thống kê Data Sponsor",

  // Revenues
  "/revenues": "Doanh thu",
  "/revenues/overview": "Tổng quan",
  "/revenues/report": "Báo cáo",
  "/revenues/statistical": "Thống kê",
  "/revenues/statistical/create-statistical": "Thêm mới dữ liệu doanh thu",
  "/revenues/statistical/edit-statistical": "Chỉnh sửa dữ liệu doanh thu",

  // System
  "/system": "Quản trị hệ thống",
  "/system/system-configuration": "Cấu hình hệ thống",
  "/system/limit-check-err-code-package": "Giới hạn kiểm tra lỗi",
};

const BreadcrumbItem = () => {
  const location = useLocation();

  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((str, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;

    let breadcrumbName = "";
    Object.keys(routes).forEach((pattern) => {
      const regex = new RegExp(pattern);

      if (regex.test(url)) {
        breadcrumbName = routes[pattern];
      }
    });

    return {
      key: url,
      title: breadcrumbName,
    };
  });

  return <Breadcrumb items={extraBreadcrumbItems} />;
};
export default BreadcrumbItem;
